import { Navigate, Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/auth/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import { AdminAlarmRulesPage } from "@/pages/AdminAlarmRulesPage";
import { AdminDevicesPage } from "@/pages/AdminDevicesPage";
import { AdminEvDcModbusTargetsPage } from "@/pages/AdminEvDcModbusTargetsPage";
import { AdminMetersPage } from "@/pages/AdminMetersPage";
import { AdminNotificationsPage } from "@/pages/AdminNotificationsPage";
import { AlarmsPage } from "@/pages/AlarmsPage";
import { DeviceDetailPage } from "@/pages/DeviceDetailPage";
import { EvChargerCommandsPage } from "@/pages/EvChargerCommandsPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { SiteDetailPage } from "@/pages/SiteDetailPage";
import { SitesPage } from "@/pages/SitesPage";

export function App() {
  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/sites" replace />} />
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/alarms" element={<AlarmsPage />} />
        <Route path="/ev-charger-commands" element={<EvChargerCommandsPage />} />
        <Route path="/sites/:siteSlug/devices/:deviceSlug" element={<DeviceDetailPage />} />
        <Route path="/sites/:siteSlug" element={<SiteDetailPage />} />
        <Route path="/admin/devices" element={<AdminDevicesPage />} />
        <Route path="/admin/alarm-rules" element={<AdminAlarmRulesPage />} />
        <Route path="/admin/ev-dc-modbus-targets" element={<AdminEvDcModbusTargetsPage />} />
        <Route path="/admin/meters" element={<AdminMetersPage />} />
        <Route path="/admin/notifications" element={<AdminNotificationsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
